import { useEffect } from 'react';

import { func } from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Select } from '@olist/design-system';
import { Box } from '@olist/united';

import useSegmentDropdown from '../hooks/useSegmentDropdown';
import { Wrapper } from './segment-dropdown.style';

const SegmentsDropdown = ({ onChangeSegments }) => {
  const { t } = useTranslation();

  const { handleChangeCheckbox, segments } = useSegmentDropdown([]);

  useEffect(() => {
    const checkedSegments = segments.filter((option) => option.value);

    onChangeSegments(checkedSegments);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [segments]);

  return (
    <Wrapper>
      <Box mt={1}>
        <Select
          id="segment-select"
          data-testid="segment-select"
          label={t`select the main category`}
          onSelect={(selectedOptions) =>
            selectedOptions && selectedOptions[0]
              ? handleChangeCheckbox({ option: selectedOptions[0].value })
              : handleChangeCheckbox({ option: '' })
          }
          required
        >
          {segments.map((option) => (
            <Select.Option key={option?.id} value={option?.id} selected={option?.value}>
              {option?.label}
            </Select.Option>
          ))}
        </Select>
      </Box>
    </Wrapper>
  );
};

SegmentsDropdown.propTypes = {
  onChangeSegments: func.isRequired,
};

export default SegmentsDropdown;
